export const BANK_ACCOUNT_TYPE_LABELS = {
  corriente: 'Cuenta Corriente',
  vista: 'Cuenta Vista',
  ahorro: 'Cuenta de Ahorro',
};

export const DEMO_DELIVERY_BY_COMMUNE = {
  Providencia: { eta: '22–35 min', fee: 2490 },
  'Las Condes': { eta: '30–45 min', fee: 3490 },
  Ñuñoa: { eta: '18–30 min', fee: 1990 },
  'Santiago Centro': { eta: '25–40 min', fee: 2990 },
};

export function labelBankAccountType(value) {
  if (value == null || String(value).trim() === '') return '—';
  const key = String(value).toLowerCase().trim();
  return BANK_ACCOUNT_TYPE_LABELS[key] ?? String(value);
}
